<template>
  <div v-if="filter.type === 'autocompSingle'">
    <v-autocomplete
      class="analytics-filter"
      dense
      v-model="filterData[`${filter.name}`]"
      :items="filter.values"
      item-text="text"
      item-value="index"
      :label="filter.title"
      @change="handleChange"
      single-line
      hide-details
      flat
      outlined
    >
      <template v-slot:prepend-inner>
        <inline-svg class="px-1" width="26" :src="filter.icon"></inline-svg>
      </template>
      <template v-slot:item="{ item }">
        <div>{{ item.text }}</div>
      </template>
    </v-autocomplete>
  </div>
  <div v-else-if="filter.type === 'select2Single'">
    <v-select
      class="analytics-filter"
      dense
      v-model="filterData[`${filter.name}`]"
      :items="filter.values"
      item-text="text"
      item-value="index"
      :label="filter.title"
      @change="handleChange"
      flat
      outlined
      single-line
      hide-details
    >
      <template v-slot:prepend-inner>
        <inline-svg class="px-1" width="26" :src="filter.icon"></inline-svg>
      </template>
      <template v-slot:item="{ item }">
        <div>{{ item.text }}</div>
      </template>
    </v-select>
  </div>
</template>

<script>
export default {
  name: "FilterTypeConsistent",
  props: ["filter", "updateFunction"],
  data: () => ({
    filterData: {},
  }),
  methods: {
    handleChange() {
      this.updateFunction(this.filterData);
    },
  },
};
</script>

<style scoped lang="scss">
.analytics-filter {
  width: 100%;

  ::v-deep .v-input__control {
    height: 45px;
    min-height: 45px;

    .v-input__slot {
      height: 45px;
      min-height: 45px;
      background: white;
      border: 1px solid #e4e6ef;
      border-radius: 0.475rem;
      box-shadow: none;
      transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

      &:hover {
        border-color: #b5b5c3;
      }

      fieldset {
        border: none;
      }

      .v-input__prepend-inner,
      .v-input__append-inner {
        margin-top: 0;
        align-self: center;
      }

      .v-label {
        font-size: 13px;
        color: #b5b5c3;
        font-weight: 500;
        top: 50%;
        transform: translateY(-50%);

        &.v-label--active {
          top: 0;
          transform: translateY(-18px) scale(0.75);
        }
      }

      .v-select__selections,
      .v-autocomplete__selections {
        padding: 0 12px;
        line-height: 45px;
      }

      .v-select__selection {
        margin: 0;
        line-height: 45px;
      }

      input {
        font-size: 14px;
        color: #3f4254;
        font-weight: 500;
        padding: 0 12px;
        line-height: 45px;
      }

      .v-icon {
        color: #b5b5c3;
      }
    }

    .v-text-field__details {
      display: none;
    }
  }

  &.v-input--is-focused {
    ::v-deep .v-input__slot {
      border-color: #7322b0;
      box-shadow: 0 0 0 0.2rem rgba(115, 34, 176, 0.1);

      .v-label {
        color: #7322b0;
      }

      .v-icon {
        color: #7322b0;
      }
    }
  }
}
</style>
